import strFunc from "@/lib/lyg/string";
import my_axios, { get_axios_data } from "@/pcomponents/common/axios";
import { useState } from 'react';
import Style from "./css/style.module.css";

function WordListArea(props: any) {
  let myProps = {
    infoArr: [],
    refreshData: (inData: any) => { },
    ...props
  };

  const [selectedWords, setSelectedWords] = useState<string[]>([]);
  const [editingWord, setEditingWord] = useState<any>(null);
  const [draggedItem, setDraggedItem] = useState<any>(null);

  const toggleWordSelection = (seq: string) => {
    let change_selected_words = [...selectedWords];
    let is_exist = false;
    for (let i = 0; i < selectedWords.length; i++) {
      if (selectedWords[i] === seq) {
        is_exist = true;
      }
    }
    if (is_exist) {
      change_selected_words = [];
      for (let i = 0; i < selectedWords.length; i++) {
        if (selectedWords[i] !== seq) {
          change_selected_words.push(selectedWords[i]);
        }
      }
    } else {
      change_selected_words.push(seq);
    }
    setSelectedWords(change_selected_words);
  };

  const selectAllWords = () => {
    if (selectedWords.length === myProps.infoArr.length) {
      setSelectedWords([]);
    } else {
      setSelectedWords(myProps.infoArr.map((word: any) => word.a_word_seq));
    }
  };

  const deleteSelectedWords = () => {
    if (selectedWords.length === 0) {
      alert('삭제할 단어를 선택해주세요.');
      return;
    }

    let del_data_arr: any = [];
    for (let i = 0; i < myProps.infoArr.length; i++) {
      let info = myProps.infoArr[i];
      if (strFunc.str_in_array(info.a_word_seq, selectedWords) != -1) {
        del_data_arr.push(info);
      }
    }

    if (del_data_arr.length === 0) {
      alert('삭제할 단어를 선택해주세요.');
      return;
    }

    if (!confirm(`선택된 ${del_data_arr.length}개의 단어를 삭제하시겠습니까?`)) {
      return;
    }
    
    let form_json_data = {
      data_arr: del_data_arr,
    };

    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/coolen/group_word/delete',
      form_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          setSelectedWords([]);
          myProps.refreshData({});
        } else {
          alert('삭제 중 오류가 발생했습니다.');
        }
      });
  };

  const startEditing = (word: any) => {
    setEditingWord({ ...word });
  };

  const cancelEditing = () => {
    setEditingWord(null);
  };

  const saveWordEdit = () => {
    if (!editingWord.a_word || !editingWord.a_mean) {
      alert('단어와 뜻을 모두 입력해주세요.');
      return;
    }

    let change_row_data = { ...editingWord };
    let form_json_data = {
      data_arr: [change_row_data],
    };

    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/coolen/group_word/write',
      form_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          setEditingWord(null);
          myProps.refreshData({});
        } else {
          alert('수정 중 오류가 발생했습니다.');
        }
      });
  };

  const handleDragStart = (e: React.DragEvent, word: any) => {
    setDraggedItem(word);
    e.dataTransfer.effectAllowed = 'move';
    e.dataTransfer.setData('text/plain', word.a_word_seq);
  };

  const handleDragOver = (e: React.DragEvent) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = 'move';
  };

  const handleDragEnter = (e: React.DragEvent) => {
    e.preventDefault();
  };

  const handleDrop = (e: React.DragEvent, targetWord: any) => {
    e.preventDefault();
    e.stopPropagation();

    if (!draggedItem || draggedItem.a_word_seq === targetWord.a_word_seq) {
      setDraggedItem(null);
      return;
    }

    const dragIndex = myProps.infoArr.findIndex((item: any) => item.a_word_seq === draggedItem.a_word_seq);
    const dropIndex = myProps.infoArr.findIndex((item: any) => item.a_word_seq === targetWord.a_word_seq);

    if (dragIndex === -1 || dropIndex === -1) {
      setDraggedItem(null);
      return;
    }

    let change_info_arr:any = [];
    for(let i=0;i<myProps.infoArr.length;i++){
      let item = myProps.infoArr[i];
      let change_item = {...item};
      if(item.a_word_seq==draggedItem.a_word_seq){
        change_item={...targetWord};
      }
      if(item.a_word_seq==targetWord.a_word_seq){
        change_item={...draggedItem};
      }
      change_info_arr.push(change_item);
    }
    for(let i=0;i<change_info_arr.length;i++){
      change_info_arr[i].a_order_num=i+1;
    }

    let form_json_data = {
      data_arr: change_info_arr,
    };
    
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/coolen/group_word/write',
      form_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          myProps.refreshData({});
        } else {
          alert('순서 변경 중 오류가 발생했습니다.');
        }
        setDraggedItem(null);
      })
      .catch((error) => {
        console.error('Error reordering words:', error);
        alert('순서 변경 중 오류가 발생했습니다.');
        setDraggedItem(null);
      });
  };

  return (
    <div className={Style.wordListArea}>
      <div className={Style.wordControls}>
        <div className={Style.controlLeft}>
          <button
            className={Style.selectButton}
            onClick={selectAllWords}
          >
            {selectedWords.length === myProps.infoArr.length ? '전체해제' : '전체선택'}
          </button>
          <span className={Style.selectionInfo}>
            선택: {selectedWords.length} / {myProps.infoArr.length}
          </span>

          <button
            className={Style.deleteButton}
            onClick={deleteSelectedWords}
            disabled={selectedWords.length === 0}
          >
            선택삭제
          </button>
        </div>
      </div>

      <div className={Style.wordList}>
        {myProps.infoArr.length === 0 ? (
          <div className={Style.emptyState}>
            등록된 단어가 없습니다.
          </div>
        ) : (
          myProps.infoArr.map((word: any, index: number) => (
            <div
              key={index}
              className={`${Style.wordItem} ${selectedWords.includes(word.a_word_seq) ? Style.selected : ''}`}
              draggable={!editingWord}
              onDragStart={(e) => handleDragStart(e, word)}
              onDragOver={handleDragOver}
              onDragEnter={handleDragEnter}
              onDrop={(e) => handleDrop(e, word)}
              style={{
                opacity: draggedItem && draggedItem.a_word_seq === word.a_word_seq ? 0.5 : 1
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                <input
                  type="checkbox"
                  checked={selectedWords.includes(word.a_word_seq)}
                  onChange={() => toggleWordSelection(word.a_word_seq)}
                  className={Style.wordCheckbox}
                />

                <div className={Style.wordNumber}>
                  {index + 1}
                </div>

                {editingWord && editingWord.a_word_seq === word.a_word_seq ? (
                  <div className={Style.editForm}>
                    <div className={Style.editRow}>
                      <input
                        type="text"
                        className={Style.editInput}
                        value={editingWord.a_word}
                        onChange={(e) => setEditingWord({ ...editingWord, a_word: e.target.value })}
                        placeholder="단어"
                      />
                      <input
                        type="text"
                        className={Style.editInput}
                        value={editingWord.a_mean}
                        onChange={(e) => setEditingWord({ ...editingWord, a_mean: e.target.value })}
                        placeholder="뜻"
                      />
                      <select
                        className={Style.editInput}
                        value={editingWord.a_cont_part || 'word'}
                        onChange={(e) => setEditingWord({ ...editingWord, a_cont_part: e.target.value })}
                      >
                        <option value="word">단어</option>
                        <option value="stc">문장</option>
                      </select>
                    </div>
                    <div className={Style.wordActions}>
                      <button
                        className={`${Style.actionButton} ${Style.saveButton}`}
                        onClick={saveWordEdit}
                      >
                        저장
                      </button>
                      <button
                        className={`${Style.actionButton} ${Style.cancelButton}`}
                        onClick={cancelEditing}
                      >
                        취소
                      </button>
                    </div>
                  </div>
                ) : (
                  <div className={Style.wordContent}>
                    <div className={Style.wordRow}>
                      <div className={Style.wordText}>
                        {word.a_word}
                      </div>
                      <div className={Style.wordMeaning}>
                        {word.a_mean}
                      </div>
                      <div className={Style.wordType}>
                        {word.a_cont_part === 'stc' ? '문장' : '단어'}
                      </div>
                    </div>
                    <div className={Style.wordActions}>
                      <button
                        className={Style.actionButton}
                        onClick={() => startEditing(word)}
                        disabled={!!editingWord}
                      >
                        수정
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default WordListArea;